import { render, staticRenderFns } from "./StudentViewStudentPlanCard.vue?vue&type=template&id=15d89dc0&"
import script from "./StudentViewStudentPlanCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewStudentPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports